<div class="wrapper">
    <ag-grid-angular
      class="ag-theme-alpine-dark ag-theme-ix"
      style="height: 100%; width: 100%;"
      [columnDefs]="columnDefs"
      [rowData]="rowData$"
      [defaultColDef]="defaultColDef"
      [rowSelection]="'multiple'"
      [animateRows]="true"
      [pagination]="pagination"
      [paginationAutoPageSize]="paginationAutoPageSize"
      (gridReady)="onGridReady($event)"
      (rowSelected)="onRowSelected($event)"
      (cellClicked)="onCellClicked($event)"
      (paginationChanged)="onPaginationChanged($event)"
      >
    </ag-grid-angular>
</div>


